import styled from "styled-components";

const AdminSection = styled.section`
  min-width: 0;
  padding: ${({ $compact }) => ($compact ? "0.75rem" : "1rem")};
  border-radius: 18px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: padding 0.28s ease;
`;

export default AdminSection;
